<template>
  <div style="padding-left: 10px; padding-right: 10px;padding-top: 10px">
    <p style="text-align:center">
      <span style=";font-family:等线;color:rgb(0,0,0);font-weight:normal"
        ><span style="font-family:等线">推广合作协议</span></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">提示条款</span>
        <span style="font-family:等线">：</span></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">欢迎您与我司【</span></span
      ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">南京大衍数字科技</span></span
      ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >有限公司】共同签署本《推广合作协议》（下称</span
        ><span style="font-family:等线"
          >“本协议”）并为我司提供业务推广服务。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >【审慎阅读】为维护您的自身权益，在您书面签署或通过网络点击同意本协议之前，请务必审慎阅读、充分理解各条款内容，特别是权利义务条款、法律适用和管辖条款。以下条款凡是以粗体及下划线标识，您应重点阅读。</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >【签约】当您按照提示填写您的个人信息、阅读并同意本协议且完成全部注册申请确认，或书面签署本协议后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我司达成一致意见并成为我司合作人员，此后您不得以未阅读</span
          ><span style="font-family:等线"
            >/不理解本协议内容/我司未作明确提示义务或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，请您立即停止任何的申请/注册/签署行为。</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >【合作关系】您与我司通过本协议建立合作关系，适用中华人民共和国法律法规及监管政策约束（不包括香港、澳门与台湾地区），但不适用《中华人民共和国劳动合同法》。</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">协议条款：</span></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >根据中华人民共和国法律法规及监管政策的相关规定，双方按照平等自愿、诚实信用的原则，就由您为我司提供运营推广服务事宜订立本服务合作协议。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第一条</span>
        <span style="font-family:等线">服务工作内容</span></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >1.1您提供/完成工作任务或提供服务的内容主要为您根据我司的规定要求</span
            ></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线">完成</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线">相关的</span
            ><span style="font-family:等线">“</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线">任务</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线">推广</span
            ><span style="font-family:等线">”服务。</span></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >1.2 您应按照我司规定的标准完成工作。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >1.3
          您承诺和保证，您具有提供本协议服务所对应的相应资质和专业能力，您依据本协议约定收取相关费用不违反任何法律法规和政策规定。若依据相关规定，您提供的相关服务和收费，应通过所在机构或以其他法律规定的方式进行，则您自行负责办理全部事宜。若因您的自身原因未办理前述事宜，则您应承担由此引起的全部法律后果，并赔偿由此给我司造成的全部经济损失。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第二条</span>
        <span style="font-family:等线">协议效力</span></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >2.1您承诺并保证您所提供的签约信息真实、准确，以免影响您和我司之间的《服务合作协议》效力。本协议条款自您书面签署之日或在我司授权的网站上发布或自线上点击确认之日起生效（以最先日期为准）。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线">2.</span></span
        ></strong
      ><strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线">2</span></span
        ></strong
      ><strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          >&nbsp;<span style="font-family:等线"
            >本协议在发生下列情形时自然终止：</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >a、 经合作公司事先同意的情况下，您主动退出服务的；</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >b、 我司终止或变更业务模式而不需要您继续履行本协议的；</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >c、 我司认为您不适合继续提供服务的；</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >d、
            我司因经营策略变更，变动协议主要条款，而您无法接受或同意的；</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >d、 其他原因导致本协议不再继续履行的。</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第三条</span>
        <span style="font-family:等线">我司的权利和义务</span></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
          ><span style="font-family:等线"
            >3.1
            您应根据我司的安排和合作公司的要求完成相关的服务，遵守相关的法律法规政策规定。</span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >3.2
          我司对您在工作成果进行验收，在我司确认验收合格的前提下我司向您支付服务费用。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第四条</span>
        <span style="font-family:等线">您的权利和义务</span></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >4.1
              您应按时尽责地完成我司要求的工作内容，并达到规定的质量标准，确保我司验收合格。因我司对您工作任务验收，发现您的工作任务验收情况为不合格，导致无法及时向您根据本协议第五条约定支付费用的，责任由您个人承担。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >4.2在完成工作过程中，不得侵犯第三方合法权益，否则一切法律责任由您个人承担。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >4.3
              您承诺在提供本协议服务的过程中严格保守我司的商业秘密及资料，未经我司书面允许，不得将商业秘密及资料向第三方透露，否则因此导致的我司的损失，由您负责赔偿。本款所说的商业秘密及资料指任何与我司相关的信息和公司业务信息，或与以上定义本协议的目的相关的所有信息，包括但不限于：与产品、服务、供应商、客户、商业计划、项目筹划方案、市场区域、调查、研发、软件、发明、商业秘密、专有技术、操作流程、设计、方案、图表、数据、人员、工程、市场与财务等有关的任何信息；您知道或应当知道系我司保密信息或所有权信息的任何信息；根据信息的性质或披露时的情况被书面标明为保密信息或所有权信息的任何信息；以口头或其他方式披露且能够在披露时被合理地识别为保密信息或所有权信息的任何信息。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >4.4除本协议约定事项外，您不能以我司名义开展任何与工作任务无关的业务或活动。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >4.5
              协议履行期间，如您因业务开展与第三方产生纠纷，应自行处理、解决，若由此导致包括但不限于经济、商誉损失的，需由您承担赔偿责任。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第五条</span>
        <span style="font-family:等线">服务报酬的支付</span></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >5.1
              我司将根据公司的运营要求，按照约定的周期向您支付费用，具体由我司相关的业务结算规则确定。该等业务结算规则根据形势需要会有浮动调整，您清楚并了解该等浮动调整为正常情况。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线">5.2 我司将以“</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线">微信</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线">转账</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线">/支付宝转账</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >”的形式向您支付服务费用。您对于我司支付的相关费用具有合法纳税的义务，我司将在服务费用支付前为您完成相关纳税申报事宜，您应承担并缴纳的相关税费（包括且不限于：增值税及其附加税费、个人所得税）。故您须同意授权并委托我司就前述服务费用完成相应的税务代扣代缴服务（我司替您代扣代缴</span
            ></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线">每次</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线">提现</span></span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线">额</span>×20%</span
          ></span
        ></strong
      ><strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线">偶然所得税）。</span></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >5.3
              您应向我司书面或在我司平台网络上传提供您的实名银行账户信息，以供我司支付服务费用。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >5.4我司服务费用的发放以您依据第5.3款提供的收款帐户为准，因您提供的收款帐户信息不实造成的一切损失由您自行承担。如您帐号变更或发生不可用等情况时，应提前及时在合作公司网络平台进行变更操作（或向我司重新书面确认提供），否则，由此造成的一切损失由您自行负责。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >5.5我司及合作公司与您的关系非劳动与劳务关系，我司及合作公司不承担您任何社保福利待遇，也不负责您的任何社会保险及其他费用。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第六条</span>
        <span style="font-family:等线">违约责任</span></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >6.1
          双方应按本协议约定履行，如有违反，守约方有权要求对方及时改正；造成对方损失的，守约方有权要求违约方赔偿。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >6.2
          因不可抗力造成损失的，彼此不负赔偿责任，但发生不可抗力一方应及时将有关情况通知另一方，并尽最大努力进行补救。本协议所称不可抗力是指不能预见、不能克服并不能避免且对一方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、火灾和风暴等以及社会事件如战争、动乱、政府行为、黑客事件、大范围电信事故等。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >6.3
          我司有权对您推荐的用户进行回访，以确认用户数据的真实性，若经我司或我司合作方判定您存在包括但不限于恶意刷取流量或虚假用户数等以不正当手段获取我司服务费用的行为，我司有权即时解除本合同并要求您返还已支付的服务费用。如我司对您尚有服务费用未支付的，我司将在该款项内直接扣除。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第七条</span>
        <span style="font-family:等线">协议的终止</span></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >7.1 发生以下情形时，本协议终止：</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >a. 协议期限届满或您提前30日书面通知我司要求终止协议的；</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >b.
          您违反协议约定，且我司书面通知后15日内仍未予改正的，我司可以书面通知的形式终止本协议；</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >c.
          您如未能达到我司的要求，我司在工作验收时将给予警告；此后如仍发生类似情况的，我司可提前终止本协议。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >d. 本协议第二条第2.3条款约定发生的情形。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >7.2
          本协议的提前终止不应影响双方于本协议提前终止日之前根据本协议已产生的权利和义务的履行。无论本协议因何原因终止，在协议终止前的行为所导致的任何赔偿和责任，您必须完全且独立地承担。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第八条</span>
        <span style="font-family:等线">涉税事务委托授权</span></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">依据第</span
        ><span style="font-family:等线">5.2款的约定，</span></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">您须自愿同意并委托【</span></span
      ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">南京大衍数字科技</span></span
      ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >有限公司】代理本合同交易项下的涉税事务，包括协助个人通过办税服务厅或委托代征机构申请办理代开普通发票业务，同时在开票环节缴纳个人所得税和开具个人完税证明（如需要）。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">您确认【</span></span
      ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">南京大衍数字科技</span></span
      ><span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线"
          >有限公司】根据本协议授权提交的相关申报资料和信息是真实、完整、准确，和符合有关法律法规的。</span
        ></span
      >
    </p>
    <p style="text-indent:36px">
      <span style=";font-family:等线;color:rgb(0,0,0);font-size:13px"
        ><span style="font-family:等线">第九条</span>
        <span style="font-family:等线">其他</span></span
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >9.1
              因履行本协议发生的纠纷，双方应友好协商解决，协商不成的，将由南京仲裁委员会仲裁解决。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p style="text-indent:36px">
      <strong
        ><span style="text-decoration:underline;"
          ><span
            style=";font-family:等线;color:rgb(0,0,0);font-weight:bold;text-underline:single;font-size:13px"
            ><span style="font-family:等线"
              >9.2我司有权在任何时候根据法律法规、政策（含税收政策）、经营需要、业务发展等对本服务合作协议进行修订、更新。任何变更经网络平台公示后即生效，您有责任浏览这些网址并知悉所有相关的变更或通知，此变更我司不单独向您发出通知。如您不同意相关变更，必须立即以书面通知的方式终止本协议。任何修订和新规则一经公布即自动生效，成为本协议的一部分。继续执行协议表示您接受经修订的协议。</span
            ></span
          ></span
        ></strong
      >
    </p>
    <p>
      <br />
    </p>
  </div>
</template>
<script>
export default {
  name: "ServiceProtocol",
  components: {},
  props: {},
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
